if (!customElements.get('mocota-ritual-stack')) {
  class MocotaRitualStack extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-ritual-slide]'));
      this.sentinels = Array.from(this.querySelectorAll('[data-ritual-sentinel]'));

      if (!this.slides.length || !this.sentinels.length || !('IntersectionObserver' in window)) return;

      this.activeIndex = -1;
      this.observer = null;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = this.sync.bind(this);
      this.motionQuery.addEventListener('change', this.onMotionChange);

      this.onClick = (event) => {
        const slide = event.target.closest('[data-ritual-slide]');
        if (!slide) return;
        
        const clickedLink = event.target.closest('a, button');
        if (clickedLink && clickedLink !== slide.querySelector('.mocota-ritual__media')) {
          return;
        }

        const url = slide.dataset.bannerUrl;
        if (url) {
          window.location.href = url;
        }
      };
      this.addEventListener('click', this.onClick);

      this.sync();
    }

    disconnectedCallback() {
      this.motionQuery?.removeEventListener('change', this.onMotionChange);
      if (this.onClick) {
        this.removeEventListener('click', this.onClick);
      }
      this.teardown();
    }

    sync() {
      if (this.motionQuery.matches) {
        this.teardown();
      } else {
        this.setup();
      }
    }

    setup() {
      if (this.observer) return;

      this.setActive(0);

      // The sticky slides all share one viewport rect once pinned, so the
      // sentinels — which stay in normal flow — are what gets observed. A
      // zero-height root band means exactly one sentinel qualifies at a time,
      // and callbacks only fire at handovers.
      //
      // The band sits low (85% down) rather than at the midline so handover
      // happens just as the incoming slide starts to rise. At the midline the
      // slide underneath would only begin receding once it was already fully
      // covered, which hides the depth cue entirely.
      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        rootMargin: '-85% 0px -15% 0px',
        threshold: 0,
      });

      this.sentinels.forEach((sentinel) => this.observer.observe(sentinel));
    }

    teardown() {
      this.observer?.disconnect();
      this.observer = null;
      this.activeIndex = -1;
      this.slides.forEach((slide) => slide.classList.remove('is-active', 'is-behind', 'is-ahead'));
    }

    onIntersect(entries) {
      const entered = entries.find((entry) => entry.isIntersecting);
      if (!entered) return;

      this.setActive(Number(entered.target.dataset.index));
    }

    setActive(index) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;

      this.slides.forEach((slide, position) => {
        slide.classList.toggle('is-active', position === index);
        slide.classList.toggle('is-behind', position < index);
        slide.classList.toggle('is-ahead', position > index);
      });
    }
  }

  customElements.define('mocota-ritual-stack', MocotaRitualStack);
}
